import React from "react";
import { StyledIcon } from "./styles";

const Icon = ({ src, color }) => {
  return <StyledIcon src={src} color={color} />;
};

export default Icon;
